//master data end points
const GET_CUSTOMERS = "/warehouseapi/v1/customer";
const GET_WAREHOUSE = "/warehouseapi/v1/warehouse";
const GET_EMPLOYEE = "/warehouseapi/v1/employee";
const GET_EMPLOYER = "/warehouseapi/v1/employer";
const GET_SUPPLIER = "/warehouseapi/v1/supplier";
const PO_NUMBERS = "/warehouseapi/v1/poswithoutqty";
const GET_COMMODITY = "/warehouseapi/v1/commodity";
const GET_CONSIGNMENT_TYPE = "/warehouseapi/v1/consignments";
const GET_INVOICE_CURRENCY = "/warehouseapi/v1/currency";
const GET_TRANSPORTER_DETAILS = "/warehouseapi/v1/transporter";
const GET_EQUIPMENT_DETAILS = "/warehouseapi/v1/equipments";
const INDENT_TRANSPORT_NUMBERS = "/warehouseapi/v1/indenttransportids";

//masterdata for po
const GET_PONOS = "/warehouseapi/v1/pos";
const GET_WONOS = "/warehouseapi/v1/workordernos";
const GET_CUSTOMER_POS = "/warehouseapi/v1/customerpo";
const GET_SECONDARY_GRN_NOS = "/warehouseapi/v1/get_secondary_sap_grn_nos";
const GET_BINS = "/warehouseapi/v1/bin";
const GET_NON_ZERO_BINS = "/warehouseapi/v1/getallnonzerobin";
const BIN_CALCULATION = "/warehouseapi/v1/unloading_details";
const GET_JOBS_IDS = "/warehouseapi/v1/jobs";

// masterdata for Diversion
const GET_PRIMARYGRNS = "/warehouseapi/v1/primarygrns";
const GET_PRIMARY_GRN_BY_ID = "/warehouseapi/v1/primarygrn";
const UPDATE_PRIMARY_GRN = "/warehouseapi/v1/primarygrn";
const GET_DIVERSIONIDS = "/warehouseapi/v1/diversionids";
const POST_CREATE_DIVERSION = "/warehouseapi/v1/diversion";
const GET_DIVERSION_BY_ID = "/warehouseapi/v1/diversion";

// Purchase Order end points
const POST_CREATE_PO = "/warehouseapi/v1/purchaseorder";
const UPDATE_PO = "/warehouseapi/v1/purchaseorder";
const GET_PO_BY_POID_NON_ZERO_QUA = "/warehouseapi/v1/purchaseorderwithoutqty";
const GET_PO_BY_POID = "/warehouseapi/v1/purchaseorder";
const DELETE_PO = "/warehouseapi/v1/purchaseorder";
const SEARCH_PO = "/warehouseapi/v1/searchpo";
const SEARCH_PO_BULK = "/warehouseapi/v1/searchpobulk";
const DELETE_PO_LINE_ITEM = "/warehouseapi/v1/deletepodetails";

// Job end points
const POST_CREATE_JOB = "/warehouseapi/v1/jobcreation";
const POST_CREATE_JOB_BULK = "/warehouseapi/v1/jobcreationbulk";
const GET_JOB_BY_JOBID = "/warehouseapi/v1/jobcreation";
const UPDATE_JOB = "/warehouseapi/v1/jobcreation";
const POST_CREATE_UNLOAD_ADVICE = "/warehouseapi/v1/unloading";
const POST_CREATE_PRIMARY_GRN = "/warehouseapi/v1/primarygrn";
const POST_CREATE_PRIMARY_GRN_BULK = "/warehouseapi/v1/primarygrnbulk";
const GET_UNLOAD_BY_UNLOADADVICEID = "/warehouseapi/v1/unloading";
const UPDATE_UNLOADADVICEID = "/warehouseapi/v1/unloading";
const CREATE_SECONDARY_GRN = "/warehouseapi/v1/secondarygrn";
const CREATE_SECONDARY_GRN_BULK = "/warehouseapi/v1/secondarygrnbulk";
const GET_SECONDARY_GRN_BY_ID = "/warehouseapi/v1/secondarygrn";
const UPDATE_SECONDARY_GRN = "/warehouseapi/v1/secondarygrn";

const SEARCH_JOB = "/warehouseapi/v1/searchjob";
const GET_VEHICALS_BY_JOBID = "/warehouseapi/v1/vehiclesbyjobid";
const GET_VEHICALS_BY_JOBID_BULK = "/warehouseapi/v1/vehiclesbyjobidbulk";
const GET_JOB_DASHBOARD = "/warehouseapi/v1/jobsbystatus";
const UPDATE_JOB_DIVERSION = "/warehouseapi/v1/diversion";
const GET_BIN_DETAILS = "/warehouseapi/v1/bin_details";
const UPDATE_BIN_DETAILS = "/warehouseapi/v1/bin_details";
const INDENT_TRANSPORT_DASHBOARD = "/warehouseapi/v1/indenttransporterdetails";
const INDENT_VEHICLE_DASHBOARD = "/warehouseapi/v1/indentvehicledetails";
const CREATE_INDENT = "/warehouseapi/v1/indent";
const POST_CREATE_INDENT_TRANSPORTER = "/warehouseapi/v1/indenttransporter";

const GET_INDENT_BY_INDENT_NO = "/warehouseapi/v1/indent";
const UPDATE_INDENT = "/warehouseapi/v1/indent";
const CREATE_LOADING_ADVICE = "/warehouseapi/v1/loading";
const GET_LOADING_ADVICE_BY_ID = "/warehouseapi/v1/loading";
const UPDATE_LOADING_ADVICE = "/warehouseapi/v1/loading";
const GET_INDNET_TRANSPORTER = "/warehouseapi/v1/indenttransporter";
const UPDATE_INDENT_TARNSPORTER = "/warehouseapi/v1/indenttransporter";
const POST_CREATE_DELIVERY = "/warehouseapi/v1/delivery";
const GET_DELIVERY = "/warehouseapi/v1/delivery";
const UPDATE_DELIVERY = "/warehouseapi/v1/delivery";
const GOODS_ISSUE = "/warehouseapi/v1/goodsissue";
const SEARCH_INDENT = "/warehouseapi/v1/searchindent";
const GET_GOODS = "/warehouseapi/v1/goodsissue";
const UPDATE_GOODS = "/warehouseapi/v1/goodsissue";
const GET_INDENT_DASHBOARD = "/warehouseapi/v1/indentbystatus";
const GET_INDENT_NUMBERS = "/warehouseapi/v1/indentnos";

// User Login API EndPoints
const USER_LOGIN = "/warehouseapi/v1/login";

// Master Api Endpoints
const CREATE_COMMODITY_MASTER = "/warehouseapi/v1/commoditymaster";
const CREATE_CURRENCY = "/warehouseapi/v1/currencycreation";
const CREATE_WO_MASTER = "/warehouseapi/v1/womastercreation";
const CREATE_PO_MASTER = "/warehouseapi/v1/pomastercreation";
const CREATE_EQUIPMENTCHECKLIST_MASTER =
  "/warehouseapi/v1/equipmentchecklistcreation";

const LIST_EQUIPMENTCHECKLIST_MASTER =
  "/warehouseapi/v1/search-equipment-checklist-master";

const GET_EQUIPMENTCHECKLIST_MASTER =
  "/warehouseapi/v1/equipmentchecklistcreation";
const UPDATE_EQUIPMENTCHECKLIST_MASTER =
  "/warehouseapi/v1/equipmentchecklistcreation";

const CREATE_PV_CATEGORY = "/warehouseapi/v1/pvcategory";
const CREATE_SAC_CODE = "/warehouseapi/v1/saccodecreation";
const CREATE_VENDOR_MASTER = "/warehouseapi/v1/vendorservicemastercreation";
const CREATE_CONSIGNMENT_MASTER = "/warehouseapi/v1/consignmenttypemaster";
const CREATE_SUPPLIER_MASTER = "/warehouseapi/v1/suppliermaster";
const CREATE_TOOLS_MASTER = "/warehouseapi/v1/toolsmaster";
const CREATE_CONTACT_MASTER = "/warehouseapi/v1/contactmaster";
const CREATE_BIN_MASTER = "/warehouseapi/v1/binmaster";
const CREATE_EMPLOYEE_MASTER = "/warehouseapi/v1/employee_master";
const CREATE_EMPLOYER_MASTER = "/warehouseapi/v1/employer_master";
const CREATE_EQUIPMENT_MASTER = "/warehouseapi/v1/equipment_master";
const CREATE_SPARE_MASTER = "/warehouseapi/v1/spare_master";
const CREATE_TRANSPORTER_MASTER = "/warehouseapi/v1/transporter_master";
const CREATE_TRANSPORTER_REPRESENTATIVE_MASTER =
  "/warehouseapi/v1/transporter_representative_master";

const CREATE_WAREHOUSE_MASTER = "/warehouseapi/v1/warehouse_master";
const GET_PV_CATEGORY = "/warehouseapi/v1/pvcategory";
const UPDATE_PV_CATEGORY = "/warehouseapi/v1/pvcategory";
const GET_SAC_CODE = "/warehouseapi/v1/saccodecreation";
const UPDATE_SAC_CODE = "/warehouseapi/v1/saccodecreation";
const GET_VENDOR_MASTER = "/warehouseapi/v1/vendorservicemastercreation";
const UPDATE_VENDOR_MASTER = "/warehouseapi/v1/vendorservicemastercreation";
const GET_COMMODITY_MASTER = "/warehouseapi/v1/commoditymaster";
const UPDATE_COMMODITY_MASTER = "/warehouseapi/v1/commoditymaster";
const GET_CURRENCY_MASTER = "/warehouseapi/v1/currencycreation";
const UPDATE_CURRENCY_MASTER = "/warehouseapi/v1/currencycreation";
const UPDATE_WO_MASTER = "/warehouseapi/v1/womastercreation";
const GET_WO_MASTER = "/warehouseapi/v1/womastercreation";
const GET_PO_MASTER = "/warehouseapi/v1/pomastercreation";

const UPDATE_PO_MASTER = "/warehouseapi/v1/pomastercreation";
const GET_CONSIGNMENT_MASTER = "/warehouseapi/v1/consignmenttypemaster";
const UPDATE_CONSIGNMENT_MASTER = "/warehouseapi/v1/consignmenttypemaster";
const GET_SUPPLIER_MASTER = "/warehouseapi/v1/suppliermaster";
const UPDATE_SUPPLIER_MASTER = "/warehouseapi/v1/suppliermaster";
const GET_TOOLS_MASTER = "/warehouseapi/v1/toolsmaster";
const UPDATE_TOOLS_MASTER = "/warehouseapi/v1/toolsmaster";
const GET_CONTACT_MASTER = "/warehouseapi/v1/contactmaster";
const UPDATE_CONTACT_MASTER = "/warehouseapi/v1/contactmaster";
const GET_BIN_MASTER = "/warehouseapi/v1/binmaster";
const UPDATE_BIN_MASTER = "/warehouseapi/v1/binmaster";
const GET_EMPLOYEE_MASTER = "/warehouseapi/v1/employee_master";
const UPDATE_EMPLOYEE_MASTER = "/warehouseapi/v1/employee_master";
const GET_EMPLOYER_MASTER = "/warehouseapi/v1/employer_master";
const UPDATE_EMPLOYER_MASTER = "/warehouseapi/v1/employer_master";

const GET_EQUIPMENT_MASTER = "/warehouseapi/v1/equipment_master";
const UPDATE_EQUIPMENT_MASTER = "/warehouseapi/v1/equipment_master";
const GET_SPARE_MASTER = "/warehouseapi/v1/spare_master";
const UPDATE_SPARE_MASTER = "/warehouseapi/v1/spare_master";
const GET_TRANSPORTER_MASTER = "/warehouseapi/v1/transporter_master";
const UPDATE_TRANSPORTER_MASTER = "/warehouseapi/v1/transporter_master";

const GET_TRANSPORTER_REPRESENTATIVE_MASTER =
  "/warehouseapi/v1/transporter_representative_master";
const UPDATE_TRANSPORTER_REPRESENTATIVE_MASTER =
  "/warehouseapi/v1/transporter_representative_master";
const GET_WAREHOUSE_MASTER = "/warehouseapi/v1/warehouse_master";
const UPDATE_WAREHOUSE_MASTER = "/warehouseapi/v1/warehouse_master";

//const CREATE_USER_MASTER = "/warehouseapi/v1/createusermaster ";

const CREATE_USER_MASTER = "/warehouseapi/v1/insertusermaster";
const GET_USER_MASTER = "/warehouseapi/v1/get_update_user";
const UPDATE_USER_MASTER = "/warehouseapi/v1/get_update_user";
const CREATE_CUSTOMER_MASTER = "/warehouseapi/v1/customermaster";
const GET_CUSTOMER_MASTER = "/warehouseapi/v1/customermaster";
const UPDATE_CUSTOMER_MASTER = "/warehouseapi/v1/customermaster";
const CONSIGNMENT_LIST_MASTER = "/warehouseapi/v1/searchconsignmenttypemaster";
const WAREHOUSE_LIST_MASTER = "/warehouseapi/v1/searchwarehousemaster";
const WAREHOUSE_CODE_BY_NAME = "/warehouseapi/v1/getwarehousecodebyname";
const WAREHOUSE_LIST_BY_EMAIL = "/warehouseapi/v1/searchusermasterbyemail";

const EQUIPMENT_LIST_MASTER = "/warehouseapi/v1/searchequipmentmaster";
const CURRENCY_LIST_MASTER = "/warehouseapi/v1/searchcurrencymaster";
const PV_CATEGORY_LIST_MASTER = "/warehouseapi/v1/searchpvcategorymaster";
const TRANSPORTER_LIST_MASTER = "/warehouseapi/v1/searchtransportermaster";
const LIST_USER_MASTER = "/warehouseapi/v1/searchusermaster";
const LIST_CUSTOMER_MASTER = "/warehouseapi/v1/searchcustomermaster";
const LIST_EMPLOYEE_MASTER = "/warehouseapi/v1/searchemployeemaster";
const LIST_EMPLOYER_MASTER = "/warehouseapi/v1/searchemployermaster";
const LIST_SUPPLIER_MASTER = "/warehouseapi/v1/searchsuppliermaster";
const LIST_TOOLS_MASTER = "/warehouseapi/v1/searchtoolsmaster";
const LIST_SPARE_MASTER = "/warehouseapi/v1/searchsparemaster";
const LIST_SAC_CODE_MASTER = "/warehouseapi/v1/searchsaccodesmaster";
const LIST_PO_MASTER = "/warehouseapi/v1/searchpomaster";
const LIST_WO_MASTER = "/warehouseapi/v1/searchwosmaster";
const LIST_BIN_MASTER = "/warehouseapi/v1/searchbinmaster";

const LIST_COMMODITY_MASTER = "/warehouseapi/v1/searchcommoditymaster";
const LIST_CONTACT_MASTER = "/warehouseapi/v1/searchcontactmaster";
const LIST_VENDOR_MASTER = "/warehouseapi/v1/searchvendorservicemaster";
const LIST_TRANSPORTER_REPRESNTATIVE_MASTER =
  "/warehouseapi/v1/searchtransrepresentativemaster";

// SAFETY ENDPOINTS
const CREATE_SAFETY_OBSERVATION = "/warehouseapi/v1/safetyobservation";
const UPDATE_SAFETY_OBSERVATION = "/warehouseapi/v1/safetyobservation";
const GET_SAFETY_OBSERVATION_BY_ID = "/warehouseapi/v1/safetyobservation";
const LIST_SAFETY_OBSERVATION = "/warehouseapi/v1/safety_observation_search";
const GET_JOBS_BY_PO_NO = "/warehouseapi/v1/jobsbypo";
const GET_ACTIVITY_TYPE_BY_PO_NO = "/warehouseapi/v1/activity_types";

// CREATE INDENT VEHICLE REPORTING
const CREATE_INDENT_VEHICLE_REPORTING = "/warehouseapi/v1/vehiclereporting";
const GET_INDENT_VEHICLE_REPORTING = "/warehouseapi/v1/vehiclereporting";
const UPDATE_INDENT_VEHICLE_REPORTING = "/warehouseapi/v1/vehiclereporting";
const GET_INDENT_VEHICLE_LOADING = "/warehouseapi/v1/indentdetails";

// const CREATE_INDENT_VEHICLE_TRACKING = '/warehouseapi/v1/indent-vehicle-tracking';
const GET_INDENT_VEHICLE_TRACKING = "/warehouseapi/v1/indent-vehicle-tracking";
const EDIT_INDENT_VEHICLE_TRACKING = "/warehouseapi/v1/indent-vehicle-tracking";

const CREATE_INDENT_VEHICLE_TRACKING =
  "/warehouseapi/v1/indent-vehicle-tracking";

const CREATE_DEPARTMENT_MASTER = "/warehouseapi/v1/create-department-master";
const DEPARTMENT_MASTER_LIST = "/warehouseapi/v1/search-department-master";
const CHA_MASTER_LIST = "/warehouseapi/v1/listChailMasterData";
const LIST_SPACE_CERTIFICATES = "/warehouseapi/v1/spacecertificate";
const CREATE_CONSIGNEE_MASTER = "/warehouseapi/v1/create-consignee-master";
const CONSIGNEE_MASTER_LIST = "/warehouseapi/v1/search-consignee-master";
const CREATE_CONSIGNER_MASTER = "/warehouseapi/v1/create-consigner-master";
const CONSIGNER_MASTER_LIST = "/warehouseapi/v1/search-consigner-master";

// safety tools and tackles
const CREATE_SAFETY_TOOLS_TACKLES = "/warehouseapi/v1/safetytools";
const UPDATE_SAFETY_TOOLS_TACKLES = "/warehouseapi/v1/safetytools";
const GET_SAFETY_TOOLS_TACKLES_BY_ID = "/warehouseapi/v1/safetytools";
const LIST_SAFETY_TOOLS_TACKLES = "/warehouseapi/v1/safety_tools_search";

// safety spare stock managment
const CREATE_SAFETY_SPARE_STOCK_MANAGMENT =
  "/warehouseapi/v1/sparestockmanagement";
const UPDATE_SAFETY_SPARE_STOCK_MANAGMENT =
  "/warehouseapi/v1/sparestockmanagement";
const GET_SAFETY_SPARE_STOCK_MANAGMENT_BY_ID =
  "/warehouseapi/v1/sparestockmanagement";
const LIST_SAFETY_SPARE_STOCK_MANAGMENT =
  "/warehouseapi/v1/sparestockmanagement";

// damage cliam
const CREATE_DAMAGE_CLIAM = "/warehouseapi/v1/damage_claim";
const UPDATE_DAMAGE_CLIAM = "/warehouseapi/v1/damage_claim";
const GET_DAMAGE_CLIAM_BY_ID = "/warehouseapi/v1/damage_claim";
const LIST_DAMAGE_CLIAM = "/warehouseapi/v1/damage_claim_search";

// Equipment Complince API  start

const CREATE_EQUIPMENT_FUEL_CONSUMPTION =
  "/warehouseapi/v1/equipment_fuel_consumption";
const UPDATE_EQUIPMENT_FUEL_CONSUMPTION =
  "/warehouseapi/v1/equipment_fuel_consumption";
const GET_EQUIPMENT_FUEL_CONSUMPTION_BY_ID =
  "/warehouseapi/v1/equipment_fuel_consumption";

const CREATE_EQUIPMENT_PREVENTIVE_MAINTENCE =
  "/warehouseapi/v1/equipment_preventive_maintenance";
const UPDATE_EQUIPMENT_PREVENTIVE_MAINTENCE =
  "/warehouseapi/v1/equipment_preventive_maintenance";
const GET_EQUIPMENT_PREVENTIVE_MAINTENCE_BY_ID =
  "/warehouseapi/v1/equipment_preventive_maintenance";

const CREATE_EQUIPMENT_COMPLIANCE = "/warehouseapi/v1/equipment_compliance";
const UPDATE_EQUIPMENT_COMPLIANCE = "/warehouseapi/v1/equipment_compliance";
const GET_EQUIPMENT_COMPLIANCE_BY_ID = "/warehouseapi/v1/equipment_compliance";
const CREATE_EQUIPMENT_MAINTENNANCE = "/warehouseapi/v1/equipment_maintenance";
const UPDATE_EQUIPMENT_MAINTENNANCE = "/warehouseapi/v1/equipment_maintenance";
const GET_EQUIPMENT_MAINTENNANCE_BY_ID =
  "/warehouseapi/v1/equipment_maintenance";

// Physical Stock Verification
const PHYSICAL_STOCK_VERIFICATION =
  "/warehouseapi/v1/physical-stock-verification";
const PHYSICAL_STOCK_VERIFICATION_SEARCH =
  "/warehouseapi/v1/search-physical-stock-verification";
const LIST_EQUIPMENT_COMPLIANCE =
  "/warehouseapi/v1/search_equipment_compliance";

// Spare Stock Management
const SPARE_STOCK_MANAGEMENT = "/warehouseapi/v1/spare-stock-management";
const SPARE_STOCK_MANAGEMENT_LIST =
  "/warehouseapi/v1/spare_stock_management_search";

// safety employeee
const CREATE_SAFETY_EMPLOYEE = "/warehouseapi/v1/safetyemployee";
const UPDATE_SAFETY_EMPLOYEE = "/warehouseapi/v1/safetyemployee";
const GET_SAFETY_EMPLOYEE_BY_ID = "/warehouseapi/v1/safetyemployee";
const LIST_SAFETY_EMPLOYEE = "/warehouseapi/v1/search-safety-empployee";

// customer invoice
const CREATE_CUSTOMER_INVOICE = "/warehouseapi/v1/customer-invoice";
const UPDATE_CUSTOMER_INVOICE = "/warehouseapi/v1/customer-invoice";
const GET_CUSTOMER_INVOICE_BY_ID = "/warehouseapi/v1/customer-invoice";
const LIST_CUSTOMER_INVOICE = "/warehouseapi/v1/search-customer-invoice";

// parameter master
const CREATE_PARAMETER_MASTER = "/warehouseapi/v1/parameter-master";
const UPDATE_PARAMETER_MASTER = "/warehouseapi/v1/parameter-master";
const GET_PARAMETER_MASTER_BY_ID = "/warehouseapi/v1/parameter-master";
const LIST_PARAMETER_MASTER = "/warehouseapi/v1/search-parameter-master";

// ECCI Document Upload
const ECCI_DOCUMENT_UPLOAD = "/warehouseapi/v1/parsejobexcel";
const SAP_GRN_DOCUMENT_UPLOAD = "/warehouseapi/v1/secondarysapgrn";

// Delivery Challan PDF
const DELIVERY_CHALLAN_PDF = "/warehouseapi/v1/generate-delivery-challan-pdf";

// Packaging List PDF
const PACKAGING_LIST_PDF = "/warehouseapi/v1/generate-packing-list-pdf";

// Unloading Advice PDF
const UNLOADING_ADVICE_PDF = "/warehouseapi/v1/generate-unloading-advice-pdf";
const JOB_COMPLETED_POS = "/warehouseapi/v1/customer-po-numbers-by-job-status";
const JOB_SECONDARY_DETAILS = "/warehouseapi/v1/primary_grn_details";

// Upload PO Document for Bulk PO Creation
const UPLOAD_PO_DOCUMENT = "/warehouseapi/v1/po-creation-by-excel-upload";
const COMPLETED_CUSTOMERS = "/warehouseapi/v1/consignee-names-by-job-status";

const COMPLETED_CUSTOMER_ACTIVITIES =
  "/warehouseapi/v1/activity_types_by_consignee_name";
const COMPLETED_POS_BY_CUSTOMER_NAME =
  "/warehouseapi/v1/job_ids_by_consignee_name_activity_types";
const COMPLETED_MULTIPLE_JOBS = "/warehouseapi/v1/job_details";

// DMS File upload
const FILE_UPLOAD_TO_DMS = "/warehouseapi/v1/dms";
const DELETE_SAFETY_EMLOYEE_ITEM = "/warehouseapi/v1/safetytools";
const CONTRACT_DETAILS = "/warehouseapi/v1/contract_details";
const WORK_ORDER_DETAILS = "/warehouseapi/v1/contract_details_by_contract_no";
const SEND_TO_SAP = "/warehouseapi/v1/saptransaction";

// const SEND_TO_SAP = '/warehouseapi/v1/saptransaction';
const GET_POS_BY_UMCS =
  "/warehouseapi/v1/get_pos_by_consignee_name_activity_types";
const GET_JOB_DETAILS_BY_POS =
  "/warehouseapi/v1/get_job_details_by_consignee_name_activity_types";

const GET_TOTAL_GROSS_WEIGHT = "/warehouseapi/v1/get_total_gross_weight";
const CREATE_MATERIAL_GROUP_MASTER = "/warehouseapi/v1/material_group_master";
const GET_MATERIAL_GROUP_MASTER = "/warehouseapi/v1/material_group_master";
const GET_CUSTOM_STATION_MASTER = "/warehouseapi/v1/getCustomsById";
const UPDATE_MATERIAL_GROUP_MASTER = "/warehouseapi/v1/material_group_master";
const UPDATE_CUSTOM_STATION_MASTER = "/warehouseapi/v1/customs";

const LIST_MATERIAL_GROUP_MASTER =
  "/warehouseapi/v1/search_material_group_master";

const GET_CUSTOMER_BY_SAP_CUSTOMER_ID =
  "/warehouseapi/v1/get_customer_by_sap_customer_id";

const GET_BINS_BY_UMCS = "/warehouseapi/v1/get_bin_details_from_job";
const GET_BINS_FOR_PRAVESH =
  "/warehouseapi/v1/get_bin_details_from_job_pravesh";
const POST_SAP_GRN_BULK_INSERT = "/warehouseapi/v1/sap_grn_details_bulk_insert";

const PRAVESH_STOCK_REPORT = "/warehouseapi/v1/getstockreceipt";
const DOWNLOADSTOCKREPORT = "/warehouseapi/v1/downloadstockreceipt";
const DOWNLOADBONDEDSTOCKREPORT = "/warehouseapi/v1/downloadbondedstockreceipt";
const DOWNLOADEXWHSTOCKREPORT = "/warehouseapi/v1/downloadstockreceiptbyexwh";
const DOWNLOADMMSTOCKREPORT = "/warehouseapi/v1/downloadstockreceiptbymmwh";
const DOWNLOADIMSTOCKREPORT = "/warehouseapi/v1/downloadstockreceiptbyims";
const DOWNLOADBOETOCKREPORT = "/warehouseapi/v1/downloadstockreceiptbyboe";
const AGRICOREPORT = "/warehouseapi/v1/getagricoreport";
const DOWNLOADAGRICOSTOCKREPORT = "/warehouseapi/v1/downloadagricoreport";
const SMDREPORT = "/warehouseapi/v1/getsmdreport";
const DOWNLOADSMDSTOCKREPORT = "/warehouseapi/v1/downloadsmdreport";

const GRNREPORT = "/warehouseapi/v1/getgrnreport";
const DOWNLOADGRNREPORT = "/warehouseapi/v1/downloadgrnreport";
const GETIMSREPORT = "/warehouseapi/v1/getstockreceiptbyims";
const VIVORECEIPTREPORT = "/warehouseapi/v1/vivoreceiptreport";
const DOWNLOADVIVORECEIPTREPORT = "/warehouseapi/v1/vivoreceiptreport";
const VIVOREPORT = "/warehouseapi/v1/vivoreport";
const DOWNLOADVIVOREPORT = "/warehouseapi/v1/vivoreport";
const PACKAGELEVELREPORT = "/warehouseapi/v1/packagelevelreport";
const DOWNLOADPACKAGELEVELREPORT = "/warehouseapi/v1/packagelevelreport";
const VIVOISSUEREPORT = "/warehouseapi/v1/vivoissuereport";
const DOWNLOADVIVOISSUEREPORT = "/warehouseapi/v1/vivoissuereport";
const GIREPORT = "/warehouseapi/v1/gireport";
const DOWNLOADGIREPORT = "/warehouseapi/v1/gireport";
const TCILREPORT = "/warehouseapi/v1/tcilreport";
const DOWNLOADTCILREPORT = "/warehouseapi/v1/tcilreport";
const IMSREPORT = "/warehouseapi/v1/imsreport";
const DOWNLOADIMSREPORT = "/warehouseapi/v1/imsreport";

// const GET_USER_MASTER = "/warehouseapi/v1/damage_claim";
// const UPDATE_DAMAGE_CLIAM = "/warehouseapi/v1/damage_claim";

const GET_PO_DETAILS_BY_BATCHNO = "/warehouseapi/v1/get_po_details_by_batch_no";

const GET_JOB_DETAILS_BY_BATCHNO =
  "/warehouseapi/v1/get_job_details_by_batch_no";

const UPLOAD_INDENT_LINE_ITEM_DOCUMENT =
  "/warehouseapi/v1/indent_details_bulk_insert";

const MATERIAL_PICK_LIST_REPORT = "/warehouseapi/v1/materialpicklistwithoutro";
const DOWNLOAD_MATERIAL_PICK_LIST_REPORT =
  "/warehouseapi/v1/materialpicklistwithoutro";

const GET_BOOKING_IDS_BY_UMC = "/warehouseapi/v1/getbookingidsbyumc";
const GET_JOB_DETAILS_BY_BOOKIND_ID = "/warehouseapi/v1/getdetailsbybookingid";

const GET_BOOKING_IDS_BY_UMC_PRIMARY_GRN =
  "/warehouseapi/v1/getbookingidsbyumcjobid";
const GET_JOB_DETAILS_BY_BOOKIND_ID_PRIMARY_GRN =
  "/warehouseapi/v1/getdetailsbybookingidjobid";

const GET_BOOKING_IDS_BY_UMC_UNLOAD =
  "/warehouseapi/v1/getbookingidsbyumcprimary";
const GET_JOB_DETAILS_BY_BOOKIND_ID_UNLOAD =
  "/warehouseapi/v1/getdetailsbybookingidprimary";

// const GET_BOOKING_IDS_BY_UMC_INDENT = "/warehouseapi/v1/getbookingidsbyumcprimary";
const GET_JOB_DETAILS_BY_BOOKIND_ID_INDENT =
  "/warehouseapi/v1/get_job_details_by_umc_booking_id";

const GET_BOOKING_IDS_BY_UMC_INDENT_LOADING =
  "/warehouseapi/v1/getbookingidsbyumcindent";
const GET_JOB_DETAILS_BY_BOOKIND_ID_INDENT_LOADING =
  "/warehouseapi/v1/getdetailsbybookingidindent";

const CREATE_JOB_CUSTOM_DETAILS = "/warehouseapi/v1/job_custom_details";
const GET_JOB_CUSTOM_DETAILS = "/warehouseapi/v1/job_custom_details";
const UPDATE_JOB_CUSTOM_DETAILS = "/warehouseapi/v1/job_custom_details";
const AUDIT_REPORT_SEARCH = "/warehouseapi/v1/auditReport";
const SAP_GRN_DLOAD = "/warehouseapi/v1/downloadsecondarysapgrnno";
const GET_TOTAL_NO_OF_PACKAGES = "/warehouseapi/v1/get_total_no_of_packages";
const AUTHENTICATION_BY_EMAIL = "/warehouseapi/v1/authentication";

// form a and form b
const FORMA = "/warehouseapi/v1/exportFormA";
const FORMB = "/warehouseapi/v1/exportFormB";
const UPLOADEXCELFROMCHAIL = "/warehouseapi/v1/uploadChailExcelMasterData";

// bond numbers
const BOND_NUMBERS = "/warehouseapi/v1/getIndentBonds";

// get all umc
const GET_ALL_UMC = "/warehouseapi/v1/getAllUMC";
const FORM_A_PDF = "/warehouseapi/v1/generateFormAPDF";
const FORM_B_PDF = "/warehouseapi/v1/generateFormBPDF";
const GET_ALL_BINS_BASED_ON_UMC = "/warehouseapi/v1/getAllBinsByUMC";
const GET_CUSTOM_STATIONS = "/warehouseapi/v1/customs";
const GET_BONDED_STOCK_REPORT = "/warehouseapi/v1/getbondedstockreport";
const LIST_CUSTOM_STATION_MASTER = "/warehouseapi/v1/customs";
const SPACE_CERTIFICATE = "/warehouseapi/v1/spacecertificate";
const SPACE_CERTIFICATE_GENERATE = "/warehouseapi/v1/generateSpaceCert";
const GENERATE_DELIVERY_CHALLAN = "/warehouseapi/v1/generateDeliveryChallan";

const JOB_CREATION_DETAILS = "/warehouseapi/v1/jobcreationdetails";
const JOB_CREATION_DETAILS_VALIDATION = "/warehouseapi/v1/jobcreationvalidation";
const INDENT_UMC_UPDATE = "/warehouseapi/v1/indentdetails";
const GET_INDENT_FOR_LOADING = "/warehouseapi/v1/get_indent_for_loading";
const GET_IMS_STOCK_REPORT = "/warehouseapi/v1/getstockreceiptbyims";
const GET_RM_STOCK_REPORT = "/warehouseapi/v1/getstockreceiptbymmwh";
const GET_EXWH_STOCK_REPORT = "/warehouseapi/v1/getstockreceiptbyexwh";
const GET_EXWH_STOCKS_REPORTS_BOE = "/warehouseapi/v1/getstockreceiptbyboe";
const UNLOAD_TEMPLATE = "/warehouseapi/v1/downloadunloadbin";
const UNLOAD_PKG_TEMPLATE = "/warehouseapi/v1/downloadunloadpkgbin";
const DOWNLOAD_PL_UNLOAD = "/warehouseapi/v1/downloadpkgbin";

const UPLOAD_UNLOAD_UMC_DATA = "/warehouseapi/v1/unloadbinvalidation";
const GET_DASHBOARD_DATA = "/warehouseapi/v1/dashboard";
const GET_INVENTORY_DASHBOARD_DATA = "/warehouseapi/v1/inventorydashboard";
const PENDING_GRN_DATA = "/warehouseapi/v1/pendinggrndashboard";
const OUTBOUND_DASHBOARD_DATA = "/warehouseapi/v1/outbounddashboard";
const AGE_WISE_STOCK_REPORT = "/warehouseapi/v1/agewisestockdashboard";
const GRN_COMPLAINCE_DATA = "/warehouseapi/v1/grncompliancedashboard";
const VIVO_COMPLAINCE_DATA = "/warehouseapi/v1/vivocompliancedashboard";
const MR_COMPLAINCE_DATA = "/warehouseapi/v1/mrcompliancedashboard";
const GET_DIVERSION_REPORT = "/warehouseapi/v1/getdiversionreport";

const DOWNLOAD_DIVERSION_REPORT = "/warehouseapi/v1/downloaddiversionreport";
const GET_SAP_PENDING_REPORT = "/warehouseapi/v1/getpendinggrnreport";
const DOWNLOAD_SAP_PENDING_REPORT = "/warehouseapi/v1/downloadpendinggrnreport";
const CANCEL_JOB = "/warehouseapi/v1/deletejob";
const SAP_PENDING_REASON_MASTER = "/warehouseapi/v1/reasonmaster";
const SEARCH_SAP_PENDING_REASON_MASTER = "/warehouseapi/v1/searchreasonmaster";
const RECEIPT_TYPE_MASTER = "/warehouseapi/v1/listreceipttypemaster";
const CREATE_RECEIPT_TYPE_MASTER = "/warehouseapi/v1/receipttypemaster";
const GET_RECEIPT_TYPE_MASTER_ID = "/warehouseapi/v1/receipttypemaster";
const UPLOAD_UNLOAD_UMC_DATA_FORMDATA = "/warehouseapi/v1/unloadbinvalidation-by-excel-upload";
const UPLOAD_UNLOAD_UMC_PKG_DATA_FORMDATA = "/warehouseapi/v1/unloadpkgbinvalidation-by-excel-upload";
const UPLOAD_UNLOAD_BIN_PKG_DATA_FORMDATA = "/warehouseapi/v1/unloadpackagebinvalidation-by-excel-upload_bulk";
const GET_DATA_FOR_PRAVESH_LOADING_UMC_MR_NUM = "/warehouseapi/v1/getdetailsbymrnumberindent";
const GRN_NOT_DONE_INDENT_NOS = "/warehouseapi/v1/get_grn_not_done_indent_nos";
const GRN_NOT_DONE_INDENT_STOCK_REGULARIZATION = "/warehouseapi/v1/downloadindentsapgrn";

const SAP_INDENT_STOCK_REGULARIZATION_UPLOAD = "/warehouseapi/v1/indentsapgrn";
const JOB_DATA_BASED_ON_DATE_RANGE = "/warehouseapi/v1/downloadjobinfo";
const GET_SETTINGS = "/settings";
const PO_DATA_UMC_WH = "/warehouseapi/v1/downloadpurchaseorderinfo"
const INDENT_DATE_BASED_ON_WH = "/warehouseapi/v1/downloadindentinfo"
const LOADING_ADVICE_UMC_DETAILS = "/warehouseapi/v1/loading_details";

const LIST_VEHICLE_TYPE_MASTER = "/warehouseapi/v1/listvehicletypemaster";
const CREATE_VEHICLE_TYPE_MASTER = "/warehouseapi/v1/vehicletypemaster";
const GET_VEHICLE_TYPE_BY_ID = "/warehouseapi/v1/vehicletypebyid";

// exwh
// const PO_TEMPLATE_TO_CREATE_JOB_EXWH = "/warehouseapi/v1/downloadpurchaseorderdet";
const PO_MASTERNAMES = "/warehouseapi/v1/pomasternames";
const PENDING_GRN_DASHBOARD_EXCEL_DOWNLOAD = "/warehouseapi/v1/downloadpendinggrndatadashboard";
const UOM_MASTER_LIST = "/warehouseapi/v1/uommaster";
const CREATE_UOM_MASTER = "/warehouseapi/v1/uommaster";
const PACKAGE_LIST_MASTER = "/warehouseapi/v1/packagetypemaster";
const CREATE_PACKAGE = "/warehouseapi/v1/packagetypemaster";
const UPDATE_PACKAGE_MASTER = "/warehouseapi/v1/packagecreation"
const GET_PACKAGE_MASTER = "/warehouseapi/v1/packagecreation";
const RELEASE_VEHICLE = "/warehouseapi/v1/jobvehiclerelease";
const LOGOUT = "/warehouseapi/v1/logout";
const RESET_TOKEN = "/warehouseapi/v1/resettoken";

const UPLOAD_UNLOAD_PACKING_LIST_UMC_DATA = "/warehouseapi/v1/unloadpackagebinvalidation-by-excel-upload";
const GET_ALL_POS_STOCK_VERIFICATION = '/warehouseapi/v1/getAllUMCStockVerification'
const GET_ALL_BOE_STOCK_VERIFICATION = '/warehouseapi/v1/getBOEQtyStockVerification';
const PENDING_OUTBOUND_DASHBOARD_EXCEL_DOWNLOAD = "/warehouseapi/v1/downloadpendingoutbounddashboard";
const AGE_WISE_STOCK_QUANTITY = "/warehouseapi/v1/agewisestockquantitydashboard";
const STOCK_QUANTITY_AGE_REPORT_DOWNLOAD = "/warehouseapi/v1/downloadagewisequantitydashboard";
const DOWNLOAD_UMC_STICKER_PACKAGES = "/warehouseapi/v1/job/downloadPackageSticker";

export default {
  GET_CUSTOMERS,
  GET_EMPLOYEE,
  GET_EMPLOYER,
  GET_SUPPLIER,
  POST_CREATE_PO,
  UPDATE_PO,
  GET_PO_BY_POID,
  DELETE_PO,
  PO_NUMBERS,
  GET_COMMODITY,
  GET_CONSIGNMENT_TYPE,
  GET_INVOICE_CURRENCY,
  GET_TRANSPORTER_DETAILS,
  POST_CREATE_JOB,
  POST_CREATE_JOB_BULK,
  UPDATE_JOB,
  POST_CREATE_UNLOAD_ADVICE,
  SEARCH_PO,
  GET_PONOS,
  GET_WONOS,
  GET_CUSTOMER_POS,
  GET_SECONDARY_GRN_NOS,
  GET_JOB_BY_JOBID,
  POST_CREATE_PRIMARY_GRN,
  POST_CREATE_PRIMARY_GRN_BULK,
  GET_PRIMARYGRNS,
  GET_PRIMARY_GRN_BY_ID,
  GET_DIVERSIONIDS,
  POST_CREATE_DIVERSION,
  GET_DIVERSION_BY_ID,
  UPDATE_PRIMARY_GRN,
  GET_BINS,
  GET_UNLOAD_BY_UNLOADADVICEID,
  UPDATE_UNLOADADVICEID,
  CREATE_SECONDARY_GRN,
  CREATE_SECONDARY_GRN_BULK,
  GET_SECONDARY_GRN_BY_ID,
  UPDATE_SECONDARY_GRN,
  SEARCH_JOB,
  GET_VEHICALS_BY_JOBID,
  GET_VEHICALS_BY_JOBID_BULK,
  CREATE_INDENT,
  GET_INDENT_BY_INDENT_NO,
  UPDATE_INDENT,
  GET_TOTAL_NO_OF_PACKAGES,
  GET_EQUIPMENT_DETAILS,
  CREATE_LOADING_ADVICE,
  GET_LOADING_ADVICE_BY_ID,
  UPDATE_LOADING_ADVICE,
  INDENT_TRANSPORT_NUMBERS,
  POST_CREATE_INDENT_TRANSPORTER,
  GET_INDNET_TRANSPORTER,
  POST_CREATE_DELIVERY,
  GET_DELIVERY,
  UPDATE_DELIVERY,
  UPDATE_INDENT_TARNSPORTER,
  GOODS_ISSUE,
  SEARCH_INDENT,
  GET_WAREHOUSE,
  GET_GOODS,
  UPDATE_GOODS,
  GET_JOB_DASHBOARD,
  UPDATE_JOB_DIVERSION,
  GET_JOBS_IDS,
  INDENT_TRANSPORT_DASHBOARD,
  GET_INDENT_DASHBOARD,
  INDENT_VEHICLE_DASHBOARD,
  CREATE_COMMODITY_MASTER,
  GET_BIN_DETAILS,
  UPDATE_BIN_DETAILS,
  CREATE_COMMODITY_MASTER,
  UPDATE_BIN_DETAILS,
  CREATE_PV_CATEGORY,
  GET_PV_CATEGORY,
  UPDATE_PV_CATEGORY,
  CREATE_SAC_CODE,
  CREATE_VENDOR_MASTER,
  CREATE_CURRENCY,
  CREATE_WO_MASTER,
  CREATE_PO_MASTER,
  CREATE_EQUIPMENTCHECKLIST_MASTER,
  CREATE_CONSIGNMENT_MASTER,
  CREATE_SUPPLIER_MASTER,
  CREATE_TOOLS_MASTER,
  CREATE_CONTACT_MASTER,
  CREATE_BIN_MASTER,
  CREATE_EMPLOYEE_MASTER,
  CREATE_EMPLOYER_MASTER,
  CREATE_EQUIPMENT_MASTER,
  CREATE_SPARE_MASTER,
  CREATE_TRANSPORTER_MASTER,
  CREATE_TRANSPORTER_REPRESENTATIVE_MASTER,
  CREATE_WAREHOUSE_MASTER,
  GET_COMMODITY_MASTER,
  GET_CURRENCY_MASTER,
  GET_WO_MASTER,
  GET_PO_MASTER,
  UPDATE_COMMODITY_MASTER,
  UPDATE_WO_MASTER,
  UPDATE_PO_MASTER,
  UPDATE_CURRENCY_MASTER,
  GET_SAC_CODE,
  UPDATE_SAC_CODE,
  GET_VENDOR_MASTER,
  UPDATE_VENDOR_MASTER,
  GET_CONSIGNMENT_MASTER,
  UPDATE_CONSIGNMENT_MASTER,
  GET_SUPPLIER_MASTER,
  UPDATE_SUPPLIER_MASTER,
  GET_TOOLS_MASTER,
  UPDATE_TOOLS_MASTER,
  GET_CONTACT_MASTER,
  UPDATE_CONTACT_MASTER,
  GET_EQUIPMENTCHECKLIST_MASTER,
  UPDATE_EQUIPMENTCHECKLIST_MASTER,
  GET_BIN_MASTER,
  UPDATE_BIN_MASTER,
  GET_EMPLOYEE_MASTER,
  UPDATE_EMPLOYEE_MASTER,
  GET_EMPLOYER_MASTER,
  UPDATE_EMPLOYER_MASTER,
  GET_EQUIPMENT_MASTER,
  UPDATE_EQUIPMENT_MASTER,
  GET_SPARE_MASTER,
  UPDATE_SPARE_MASTER,
  GET_TRANSPORTER_MASTER,
  UPDATE_TRANSPORTER_MASTER,
  GET_TRANSPORTER_REPRESENTATIVE_MASTER,
  UPDATE_TRANSPORTER_REPRESENTATIVE_MASTER,
  GET_WAREHOUSE_MASTER,
  UPDATE_WAREHOUSE_MASTER,
  USER_LOGIN,
  CONSIGNMENT_LIST_MASTER,
  CREATE_USER_MASTER,
  GET_USER_MASTER,
  UPDATE_USER_MASTER,
  LIST_USER_MASTER,
  CREATE_CUSTOMER_MASTER,
  GET_CUSTOMER_MASTER,
  UPDATE_CUSTOMER_MASTER,
  LIST_CUSTOMER_MASTER,
  GET_INDENT_NUMBERS,
  WAREHOUSE_LIST_MASTER,
  WAREHOUSE_CODE_BY_NAME,
  WAREHOUSE_LIST_BY_EMAIL,
  CURRENCY_LIST_MASTER,
  TRANSPORTER_LIST_MASTER,
  PV_CATEGORY_LIST_MASTER,
  EQUIPMENT_LIST_MASTER,
  LIST_EMPLOYEE_MASTER,
  LIST_EMPLOYER_MASTER,
  LIST_SUPPLIER_MASTER,
  LIST_TOOLS_MASTER,
  LIST_SPARE_MASTER,
  LIST_SAC_CODE_MASTER,
  LIST_PO_MASTER,
  LIST_WO_MASTER,
  LIST_BIN_MASTER,
  LIST_COMMODITY_MASTER,
  LIST_CONTACT_MASTER,
  LIST_TRANSPORTER_REPRESNTATIVE_MASTER,
  LIST_VENDOR_MASTER,
  CREATE_SAFETY_OBSERVATION,
  UPDATE_SAFETY_OBSERVATION,
  GET_SAFETY_OBSERVATION_BY_ID,
  GET_JOBS_BY_PO_NO,
  GET_ACTIVITY_TYPE_BY_PO_NO,
  DELETE_PO_LINE_ITEM,
  CREATE_INDENT_VEHICLE_REPORTING,
  GET_INDENT_VEHICLE_LOADING,
  GET_INDENT_VEHICLE_REPORTING,
  UPDATE_INDENT_VEHICLE_REPORTING,
  CREATE_INDENT_VEHICLE_TRACKING,
  EDIT_INDENT_VEHICLE_TRACKING,
  GET_INDENT_VEHICLE_TRACKING,
  CREATE_DEPARTMENT_MASTER,
  DEPARTMENT_MASTER_LIST,
  CHA_MASTER_LIST,
  CREATE_CONSIGNEE_MASTER,
  CONSIGNEE_MASTER_LIST,
  CONSIGNER_MASTER_LIST,
  CREATE_CONSIGNER_MASTER,
  LIST_SAFETY_OBSERVATION,
  CREATE_SAFETY_TOOLS_TACKLES,
  UPDATE_SAFETY_TOOLS_TACKLES,
  GET_SAFETY_TOOLS_TACKLES_BY_ID,
  LIST_SAFETY_TOOLS_TACKLES,
  CREATE_SAFETY_SPARE_STOCK_MANAGMENT,
  UPDATE_SAFETY_SPARE_STOCK_MANAGMENT,
  GET_SAFETY_SPARE_STOCK_MANAGMENT_BY_ID,
  LIST_SAFETY_SPARE_STOCK_MANAGMENT,
  CREATE_DAMAGE_CLIAM,
  UPDATE_DAMAGE_CLIAM,
  GET_DAMAGE_CLIAM_BY_ID,
  LIST_DAMAGE_CLIAM,
  LIST_EQUIPMENTCHECKLIST_MASTER,
  CREATE_EQUIPMENT_FUEL_CONSUMPTION,
  UPDATE_EQUIPMENT_FUEL_CONSUMPTION,
  GET_EQUIPMENT_FUEL_CONSUMPTION_BY_ID,
  CREATE_EQUIPMENT_PREVENTIVE_MAINTENCE,
  UPDATE_EQUIPMENT_PREVENTIVE_MAINTENCE,
  GET_EQUIPMENT_PREVENTIVE_MAINTENCE_BY_ID,
  CREATE_EQUIPMENT_COMPLIANCE,
  UPDATE_EQUIPMENT_COMPLIANCE,
  GET_EQUIPMENT_COMPLIANCE_BY_ID,
  CREATE_EQUIPMENT_MAINTENNANCE,
  UPDATE_EQUIPMENT_MAINTENNANCE,
  GET_EQUIPMENT_MAINTENNANCE_BY_ID,
  PHYSICAL_STOCK_VERIFICATION,
  PHYSICAL_STOCK_VERIFICATION_SEARCH,
  LIST_EQUIPMENT_COMPLIANCE,
  SPARE_STOCK_MANAGEMENT,
  SPARE_STOCK_MANAGEMENT_LIST,
  CREATE_SAFETY_EMPLOYEE,
  GET_SAFETY_EMPLOYEE_BY_ID,
  UPDATE_SAFETY_EMPLOYEE,
  CREATE_CUSTOMER_INVOICE,
  GET_CUSTOMER_INVOICE_BY_ID,
  LIST_CUSTOMER_INVOICE,
  UPDATE_CUSTOMER_INVOICE,
  CREATE_PARAMETER_MASTER,
  UPDATE_PARAMETER_MASTER,
  GET_PARAMETER_MASTER_BY_ID,
  LIST_PARAMETER_MASTER,
  LIST_SAFETY_EMPLOYEE,
  ECCI_DOCUMENT_UPLOAD,
  SAP_GRN_DOCUMENT_UPLOAD,
  DELIVERY_CHALLAN_PDF,
  PACKAGING_LIST_PDF,
  UNLOADING_ADVICE_PDF,
  JOB_COMPLETED_POS,
  JOB_SECONDARY_DETAILS,
  UPLOAD_PO_DOCUMENT,
  COMPLETED_CUSTOMERS,
  COMPLETED_CUSTOMER_ACTIVITIES,
  COMPLETED_POS_BY_CUSTOMER_NAME,
  COMPLETED_MULTIPLE_JOBS,
  FILE_UPLOAD_TO_DMS,
  DELETE_SAFETY_EMLOYEE_ITEM,
  BIN_CALCULATION,
  CONTRACT_DETAILS,
  WORK_ORDER_DETAILS,
  SEND_TO_SAP,
  GET_POS_BY_UMCS,
  GET_JOB_DETAILS_BY_POS,
  GET_TOTAL_GROSS_WEIGHT,
  CREATE_MATERIAL_GROUP_MASTER,
  GET_MATERIAL_GROUP_MASTER,
  UPDATE_MATERIAL_GROUP_MASTER,
  LIST_MATERIAL_GROUP_MASTER,
  GET_CUSTOMER_BY_SAP_CUSTOMER_ID,
  GET_BINS_BY_UMCS,
  GET_BINS_FOR_PRAVESH,
  POST_SAP_GRN_BULK_INSERT,
  PRAVESH_STOCK_REPORT,
  DOWNLOADSTOCKREPORT,
  DOWNLOADEXWHSTOCKREPORT,
  DOWNLOADMMSTOCKREPORT,
  AGRICOREPORT,
  DOWNLOADAGRICOSTOCKREPORT,
  SMDREPORT,
  DOWNLOADSMDSTOCKREPORT,
  GRNREPORT,
  DOWNLOADGRNREPORT,
  GETIMSREPORT,
  VIVORECEIPTREPORT,
  DOWNLOADVIVORECEIPTREPORT,
  VIVOREPORT,
  DOWNLOADVIVOREPORT,
  PACKAGELEVELREPORT,
  DOWNLOADPACKAGELEVELREPORT,
  VIVOISSUEREPORT,
  DOWNLOADVIVOISSUEREPORT,
  GIREPORT,
  DOWNLOADGIREPORT,
  TCILREPORT,
  DOWNLOADTCILREPORT,
  IMSREPORT,
  DOWNLOADIMSREPORT,
  GET_PO_DETAILS_BY_BATCHNO,
  GET_JOB_DETAILS_BY_BATCHNO,
  UPLOAD_INDENT_LINE_ITEM_DOCUMENT,
  MATERIAL_PICK_LIST_REPORT,
  DOWNLOAD_MATERIAL_PICK_LIST_REPORT,
  GET_BOOKING_IDS_BY_UMC,
  GET_JOB_DETAILS_BY_BOOKIND_ID,
  GET_BOOKING_IDS_BY_UMC_PRIMARY_GRN,
  GET_JOB_DETAILS_BY_BOOKIND_ID_PRIMARY_GRN,
  GET_BOOKING_IDS_BY_UMC_UNLOAD,
  GET_JOB_DETAILS_BY_BOOKIND_ID_UNLOAD,
  // GET_BOOKING_IDS_BY_UMC_INDENT,
  GET_JOB_DETAILS_BY_BOOKIND_ID_INDENT,
  GET_BOOKING_IDS_BY_UMC_INDENT_LOADING,
  GET_JOB_DETAILS_BY_BOOKIND_ID_INDENT_LOADING,
  CREATE_JOB_CUSTOM_DETAILS,
  GET_JOB_CUSTOM_DETAILS,
  UPDATE_JOB_CUSTOM_DETAILS,
  AUDIT_REPORT_SEARCH,
  SAP_GRN_DLOAD,
  LIST_CUSTOM_STATION_MASTER,
  GET_CUSTOM_STATION_MASTER,
  UPDATE_CUSTOM_STATION_MASTER,
  // AUTHENTICATIO
  AUTHENTICATION_BY_EMAIL,
  // form a and form b
  FORMA,
  FORMB,
  UPLOADEXCELFROMCHAIL,
  // bond numbers
  BOND_NUMBERS,
  GET_ALL_UMC,
  FORM_A_PDF,
  FORM_B_PDF,
  GET_ALL_BINS_BASED_ON_UMC,
  GET_CUSTOM_STATIONS,
  GET_BONDED_STOCK_REPORT,
  DOWNLOADBONDEDSTOCKREPORT,
  DOWNLOADEXWHSTOCKREPORT,
  DOWNLOADIMSTOCKREPORT,
  DOWNLOADBOETOCKREPORT,
  SPACE_CERTIFICATE,
  LIST_SPACE_CERTIFICATES,
  SPACE_CERTIFICATE_GENERATE,
  JOB_CREATION_DETAILS,
  JOB_CREATION_DETAILS_VALIDATION,
  INDENT_UMC_UPDATE,
  GET_INDENT_FOR_LOADING,
  GET_NON_ZERO_BINS,
  GET_IMS_STOCK_REPORT,
  GET_RM_STOCK_REPORT,
  GET_EXWH_STOCK_REPORT,
  GET_EXWH_STOCKS_REPORTS_BOE,
  SEARCH_PO_BULK,
  UNLOAD_TEMPLATE,
  UNLOAD_PKG_TEMPLATE,
  UPLOAD_UNLOAD_UMC_DATA,
  GENERATE_DELIVERY_CHALLAN,
  GET_DASHBOARD_DATA,
  CANCEL_JOB,
  SAP_PENDING_REASON_MASTER,
  SEARCH_SAP_PENDING_REASON_MASTER,
  GET_INVENTORY_DASHBOARD_DATA,
  PENDING_GRN_DATA,
  OUTBOUND_DASHBOARD_DATA,
  AGE_WISE_STOCK_REPORT,
  GRN_COMPLAINCE_DATA,
  VIVO_COMPLAINCE_DATA,
  MR_COMPLAINCE_DATA,
  GET_DIVERSION_REPORT,
  GET_SAP_PENDING_REPORT,
  DOWNLOAD_SAP_PENDING_REPORT,
  DOWNLOAD_DIVERSION_REPORT,
  RECEIPT_TYPE_MASTER,
  CREATE_RECEIPT_TYPE_MASTER,
  GET_RECEIPT_TYPE_MASTER_ID,
  UPLOAD_UNLOAD_UMC_DATA_FORMDATA,
  UPLOAD_UNLOAD_UMC_PKG_DATA_FORMDATA,
  GET_DATA_FOR_PRAVESH_LOADING_UMC_MR_NUM,
  GRN_NOT_DONE_INDENT_NOS,
  // PO_TEMPLATE_TO_CREATE_JOB_EXWH,
  GRN_NOT_DONE_INDENT_STOCK_REGULARIZATION,
  SAP_INDENT_STOCK_REGULARIZATION_UPLOAD,
  JOB_DATA_BASED_ON_DATE_RANGE,
  GET_SETTINGS,
  PO_DATA_UMC_WH,
  INDENT_DATE_BASED_ON_WH,
  LOADING_ADVICE_UMC_DETAILS,
  LIST_VEHICLE_TYPE_MASTER,
  CREATE_VEHICLE_TYPE_MASTER,
  GET_VEHICLE_TYPE_BY_ID,
  PO_MASTERNAMES,
  PENDING_GRN_DASHBOARD_EXCEL_DOWNLOAD,
  UOM_MASTER_LIST,
  CREATE_UOM_MASTER,
  PACKAGE_LIST_MASTER,
  CREATE_PACKAGE,
  UPDATE_PACKAGE_MASTER,
  GET_PACKAGE_MASTER,
  RELEASE_VEHICLE,
  LOGOUT,
  RESET_TOKEN,

  UPLOAD_UNLOAD_PACKING_LIST_UMC_DATA,
  DOWNLOAD_PL_UNLOAD,
  UPLOAD_UNLOAD_BIN_PKG_DATA_FORMDATA,
  GET_PO_BY_POID_NON_ZERO_QUA,
  GET_ALL_POS_STOCK_VERIFICATION,
  GET_ALL_BOE_STOCK_VERIFICATION,
  PENDING_OUTBOUND_DASHBOARD_EXCEL_DOWNLOAD,
  AGE_WISE_STOCK_QUANTITY,
  STOCK_QUANTITY_AGE_REPORT_DOWNLOAD,
  DOWNLOAD_UMC_STICKER_PACKAGES
};
